import React, {Dispatch} from "react";
import { BrowserRouter as Router, Link } from "react-router-dom";
import MainHeader from "./Header/MainHeader";
import CenterPane from "./CenterPane/CenterPane";
import MainFooter from "./Footer/MainFooter";
import SiteContainerPane from "./Loader/SiteContainerPane";
import {AppState} from "../store/reducers/rootReducer";
import {connect} from "react-redux";
import {loadInitial} from "../hooks/initial/loadInitial";
import {areMainLoaded, isFullyLoaded} from "../store/selectors/load/load.selector";
import {Button} from "react-bootstrap";
import {isConsentStatusAvailable, setUserConsent} from "../hooks/user/userFunctions";

interface PropertiesFromState {
  isFullyLoaded: boolean,
  areMainLoaded: boolean,
}

interface DispatchFunctions {
  initializeData: () => void,
}

type LocalProps = PropertiesFromState & DispatchFunctions;

interface LocalState {
  showConsentBanner: boolean,
}

const mapStateToProps = (state: AppState): PropertiesFromState => {
  return {
    isFullyLoaded: isFullyLoaded(state),
    areMainLoaded: areMainLoaded(state),
  }
}

const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchFunctions => {
  return {
    initializeData: () => loadInitial(dispatch),
  }
}

class TVBIZZPage extends React.Component<LocalProps, LocalState> { // do the loading of initial data here
  state: LocalState = {
    showConsentBanner: typeof document !== "undefined" ? !isConsentStatusAvailable() : false,
  }

  closeConsentBanner = () => this.setState({showConsentBanner: false})

  handleConsent = (isConsentGiven: boolean) => {
    setUserConsent(isConsentGiven, this.closeConsentBanner)
  }

  componentDidMount() {
    this.props.initializeData()
  }

  render() {
    return (
      <Router>
        <SiteContainerPane>
          {this.props.areMainLoaded && <MainHeader/>}
          {this.props.areMainLoaded && <CenterPane/>}
          {this.props.isFullyLoaded && this.state.showConsentBanner && (
            <div className="cookie-banner">
              <div className="cookie-banner__text">
                <span className="cookie-banner__title">We only need a small confirmation:</span>
                To make TVBIZZ work, we use cookies to track user activity. By clicking on Ok, you agree to our{" "}
                <Link to={'/privacy'}>Privacy Policy</Link>, including our cookie policy.
              </div>
              <div className="cookie-banner__actions">
                <Button onClick={() => this.handleConsent(false)} variant="outline-primary" className="tvbizz-outline-primary">
                  Do not track
                </Button>
                <Button onClick={() => this.handleConsent(true)} variant="tvbizz-primary" className="tvbizz-primary">
                  Ok, continue to TVBIZZ
                </Button>
              </div>
            </div>
          )}
          {this.props.areMainLoaded && <MainFooter/>}
        </SiteContainerPane>
      </Router>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TVBIZZPage);
